<template>
  <div class="content-view">
    <div class="msg-contain">
      <el-tabs v-model="TabsValue">
        <el-tab-pane
          style="border-radius: 3px"
          v-for="item in Tabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >
          <component
            style="border-radius: 3px;margin: 15px 10px 0px 10px;"
            :is="item.content"
            :siteRow="siteRow"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import logList from "./logList";
import dataStatic from "./dataStatic";
export default {
  name: "",
  data() {
    return {
      TabsValue: "dataStatic",
      Tabs: [
        {
          title: "数据统计",
          name: "dataStatic",
          content: "dataStatic",
        },
        {
          title: "日志列表",
          name: "logList",
          content: "logList",
        },
      ],
      query: {},
      siteRow: {},
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.query = val.query;
        if (Object.keys(this.query).length != 0) {
          this.TabsValue = "logList";
          this.siteRow = this.query.siteRow;
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  components: { logList, dataStatic },
  created() {},
  mounted() {
    let kyword = localStorage.getItem("keyword");
    if (kyword.length > 0) {
      localStorage.setItem('keyword', '')
      this.TabsValue = "logList";
    }
  },
  methods: {},
  //每次激活时
  activated() {},
};
</script>
<style lang='scss' scoped>
.msg-contain {
  padding: 0px 0px 20px 0px;
  background-color: rgba(7, 31, 82, 0.2);
  border: 2px solid rgba(164, 196, 230, 0.2);
  height: 100%;
  box-sizing: border-box;
  padding: 0;
}
</style>
